import {
  Divider as MuiDivider,
} from '@material-ui/core'

export default MuiDivider